import { connect } from 'react-redux';
import DropColumnButton from './DropColumnButton';
import { dropFirstColumn } from 'actions/projects';

const mapStateToProps = state => {
  const { user, ...stateToPromote } = state;
  return {
    stateToPromote,
    user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dropFirstColumn: () => dispatch(dropFirstColumn()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DropColumnButton);



// WEBPACK FOOTER //
// ./src/components/DropColumnButton/container.js